import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [tenant, setTenant] = useState(null);
  const [status, setStatus] = useState("checking"); // checking | authed | guest

  const load = useCallback(async () => {
    if (!localStorage.getItem("pnc_token")) {
      setStatus("guest");
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setTenant(data.tenant);
      setStatus("authed");
    } catch {
      setStatus("guest");
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const login = useCallback((token, u, t) => {
    localStorage.setItem("pnc_token", token);
    setUser(u);
    setTenant(t);
    setStatus("authed");
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("pnc_token");
    setUser(null);
    setTenant(null);
    setStatus("guest");
  }, []);

  const refreshTenant = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setTenant(data.tenant);
    } catch {}
  }, []);

  return (
    <AuthContext.Provider value={{ user, tenant, status, login, logout, setTenant, refreshTenant }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
